module.exports = __webpack_public_path__ + "static/media/cate-sport.ec443971.png";